// global axiosProfileData
// **************************************************
// Load more, filter and sort via Axios
// **************************************************
if (document.querySelector('.sc-products')) {
  const filterButtons = document.querySelectorAll('.filter-item__checkbox-list input');
  const clearFilters = document.querySelectorAll('.mod-filter__reset-button');
  const slider = document.getElementById('range-slider-input');
  const startEndInput = document.querySelectorAll('#price-start, #price-end');

  const getSelectedItems = (selector) =>
    [...document.querySelectorAll(selector)].filter((input) => input.checked).map(({ id }) => id);
  const setPageEvents = () => {
    document.querySelectorAll('.page-numbers').forEach((page) => {
      page.addEventListener('click', (event) => {
        event.preventDefault();
        loadMoreAxios(Number(page.dataset.page));
      });
    });
  };

  const loadMoreAxios = (pageNumber = 1) => {
    const formDataInput = new FormData();
    const [min, max] = slider.noUiSlider.get();
    formDataInput.append('action', 'shopCategoryLoadMore');
    formDataInput.append('id', localData.categoryID);
    formDataInput.append('brands', getSelectedItems('#brand-filter-box input'));
    formDataInput.append('filters', getSelectedItems('#available-filter-box input'));
    formDataInput.append('perPage', getSelectedItems('.dropdown__main input[name="perPage"]'));
    formDataInput.append('order', getSelectedItems('.dropdown__main input[name="types"]'));
    formDataInput.append('otherfilters', getSelectedItems('.other input'));
    formDataInput.append('min', min);
    formDataInput.append('max', max);
    formDataInput.append('number', pageNumber);
    formDataInput.append('s', document.querySelector('#search').value);
    axios
      .post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          document.querySelector('.sc-breadcrumbs').scrollIntoView({ behavior: 'smooth', block: 'center' });
          document.querySelector('.product-list').innerHTML = response.data.product;
          document.querySelector('span.products__results-label').innerHTML = response.data.productText;
          document.querySelector('.pagination-box').innerHTML = response.data.pagination;
          document.querySelector('span.products__results-count').innerHTML = response.data.numberOf;
          setPageEvents();
          let url = '';
          ['id', 'brands', 'filters', 'perPage', 'order', 'min', 'max', 'number', 's', 'otherfilters'].forEach(
            (item) => {
              if (formDataInput.get(item)) {
                url += `${item}=${formDataInput.get(item)}&`;
              }
            },
          );
          window.history.pushState({ urlPath: window.location.href }, null, `?${url}`);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  startEndInput.forEach((item, key) => {
    item.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        const value = parseFloat(event.target.value);
        if (!isNaN(value)) {
          slider.noUiSlider.set(key === 1 ? [null, value] : [value, null]);
          loadMoreAxios();
        }
      }
    });
  });
  if (clearFilters) {
    clearFilters.forEach((clearFilter) => {
      clearFilter.addEventListener('click', () => {
        filterButtons.forEach((button) => {
          // eslint-disable-next-line no-param-reassign
          button.checked = false;
        });
        loadMoreAxios();
      });
    });
  }
  if (filterButtons) {
    filterButtons.forEach((filter) => {
      filter.addEventListener('click', () => {
        loadMoreAxios();
      });
    });
  }
  const sortButtons = document.querySelectorAll('.dropdown__main input');
  if (sortButtons) {
    sortButtons.forEach((sortBy) => {
      sortBy.addEventListener('click', () => {
        loadMoreAxios();
      });
    });
  }
  if (slider) {
    slider.noUiSlider.on('change', () => {
      loadMoreAxios();
    });
  }
  setPageEvents();
}

attachEvent('.add-to-cart-btn', 'click', (e) => {
  e.preventDefault();
  addItemToCart(e);
});

const addItemToCart = async (e) => {
  const nonceAction = 'add_item';
  const cartNonce = await getNonceForAction(nonceAction);
  const product = e.target.closest('.product-card, .add-cart');
  e.target.closest('.add-to-cart-btn').innerHTML = '<div class="load-spinner"></div>';
  const productID = product.dataset.product_id;
  const products = [];
  let numberOf = '1';
  if (product.querySelector('input.counter__input')) {
    numberOf = product.querySelector('.counter__input').value;
  }
  const variable = {};
  document.querySelectorAll('.dropdown__list-item input').forEach((item) => {
    if (item.checked) {
      variable[item.name] = item.id;
    }
  });
  products.push({
    productID,
    quantity: numberOf,
    variable,
  });
  await axiosAddItmesToCart(products, cartNonce, nonceAction);
  const headerNonce = await getNonceForAction('profile_dropdown');
  axiosProfileData(headerNonce);
  setTimeout(() => {
    window.location = localData.cartURL;
  }, 1000);
};
